import { Link, useMatch, useResolvedPath, useLocation } from "react-router-dom";

export default function Navbar() {
  const location = useLocation(); // current route

  return (
    <nav className="nav">
      <ul>
        {location.pathname === "/" && (
          <CustomLink to="/products">
            <span className="first-letter">P</span>
            <span className="rest">roducts</span>
          </CustomLink>
        )}
        {location.pathname === "/products" && (
          <CustomLink to="/">
            <span className="first-letter">H</span>
            <span className="rest">ome</span>
          </CustomLink>
        )}
      </ul>
    </nav>
  );
}

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props} className="expand-btn">
        {children}
      </Link>
    </li>
  );
}
